import './styles.scss'
import React from 'react'
import { I18n } from 'react-redux-i18n'

import ModalWrapper from 'components/ModalWrapper'
import { Button, TextWithCopy } from 'components/Form'
import { getStaticImage } from 'utils/statics'

const DelegateResultModal = ({
  isOpen,
  toggle,
  resultType,
  mainText,
  detailText,
  textToCopy,
  isLoadingMain,
  isLoadingAlternative,
  onClickMain,
  onClickAlternative
}) => (
  <ModalWrapper
    isOpen={isOpen}
    toggle={toggle}
    header={' '}
    body={
      <div className='delegate-result-modal__body'>
        <figure className='delegate-result-modal__icon'>
          {resultType === 'ok' && <img src={getStaticImage('/icons/orange-brand/icon-check-full.svg')} alt='Successful' />}
          {resultType === 'warning' && <img src={getStaticImage('/icons/orange-brand/icon-warning-yellow.svg')} alt='Warning' />}
          {resultType === 'error' && <img src={getStaticImage('/icons/orange-brand/icon-warning-red.svg')} alt='Error' />}
          {['consent', 'consent-admin', 'consent-operator'].includes(resultType) && <img src={getStaticImage('/icons/orange-brand/icon-padlock.svg')} alt='Restricted' />}
        </figure>
        <p className='delegate-result-modal__text-main'>{mainText}</p>
        <p className='delegate-result-modal__text-detail'>{detailText}</p>
      </div>
    }
    footer={
      <div className='delegate-result-modal__footer'>
        {resultType !== 'consent-operator' ? (
          <Button
            secondary
            className={resultType === 'consent'
              ? 'delegate-result-modal__large-btn'
              : null
            }
            isSubmitting={isLoadingMain}
            value={resultType === 'consent'
              ? I18n.t('dashboard_im-administrator')
              : resultType === 'consent-admin'
                ? I18n.t('dashboard_allow-app')
                : 'OK'
            }
            onClick={() => typeof onClickMain === 'function' ? onClickMain() : null}
          />
        ) : null}
        {resultType === 'consent' ? (
          <Button
            clearGray
            isSubmitting={isLoadingAlternative}
            value={I18n.t('dashboard_im-not-administrator')}
            onClick={() => typeof onClickAlternative === 'function' ? onClickAlternative() : null}
          />
        ) : null}
        {resultType === 'consent-operator' ? (
          <TextWithCopy value={textToCopy} />
        ) : null}
      </div>
    }
  />
)

export default DelegateResultModal
